import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

/** Üretimde beklenmeyen render hatalarında tam beyaz ekran yerine mesaj gösterir. */
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(err: Error): State {
    return { hasError: true, message: err?.message || 'Bilinmeyen hata' };
  }

  componentDidCatch(err: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', err, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="celestial-page" style={{ padding: '2rem' }}>
          <div className="celestial-glass" style={{ maxWidth: 520, padding: '2rem' }}>
            <h1 className="celestial-headline-lg">Sayfa yüklenirken hata oluştu</h1>
            <p className="celestial-body-lg">{this.state.message}</p>
            <p style={{ marginTop: '1rem' }}>
              <Link to="/" className="celestial-btn-ghost">Ana sayfaya dön</Link>
              {' · '}
              <Link to="/giris" className="celestial-btn-ghost">Giriş</Link>
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
